var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotaiaYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.2 31.2",
    style: {
      enableBackground: "new 0 0 31.2 31.2"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFE921;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FBFBFB;stroke-miterlimit:10;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,2c2.4-0.5,4.9-0.3,7.1,0.8c2,1,3.7,2.5,4.8,4.5c1.1,1.9,1.6,4.2,1.3,6.4c-0.3,1.9-1.1,3.7-2.2,5.3 c-0.9,1.4-2,2.7-3.1,4c-1.8,2.2-3.7,4.4-5.6,6.6c-2.1-2.3-4.3-4.6-6.3-7c-1.4-1.6-2.7-3.3-3.6-5.2c-0.9-1.9-1.2-4.1-0.9-6.3 c0.3-2.2,1.4-4.4,2.9-6C9.1,3.5,11.1,2.4,13.1,2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.9,8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "22,16.3 8.5,16.3 12.2,4.8 18.3,4.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 8.7,
    y1: 10.3,
    x2: 22,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.1,
    y1: 14.2,
    x2: 23.6,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 10.1,
    y1: 6.3,
    x2: 20.8,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.1,4 7.5,17.2 9.8,17.2 13.3,4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.7,4 23.5,17.2 21.1,17.2 17.5,4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotaiaYellow);
export default __webpack_public_path__ + "static/media/rotaia_yellow.fb0c4ecab2380e76e1bb2a4a8ab56d0a.svg";
export { ForwardRef as ReactComponent };